import React, { useState } from "react";
import { X } from "lucide-react";

export default function LocationFormModal({ initial, onClose, onSave }) {
  const [form, setForm] = useState(() =>
    initial || { name: "", address: "", lat: 0, lng: 0, tax: 18, minBookingDays: 1 }
  );
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.address) return;
    onSave({
      ...form,
      lat: +form.lat,
      lng: +form.lng,
      tax: +form.tax,
      minBookingDays: Math.max(1, +form.minBookingDays || 1),
    });
  };

  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal-card" style={{ maxWidth: 520 }} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between mb-5">
          <h2 className="text-2xl font-extrabold">{initial ? "Edit Location" : "Add Location"}</h2>
          <button className="text-gray-400 hover:text-gray-700" onClick={onClose}><X size={22} /></button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="field-label">Name *</label>
            <input className="input-soft" value={form.name} onChange={(e) => set("name", e.target.value)} required />
          </div>
          <div>
            <label className="field-label">Address *</label>
            <input className="input-soft" value={form.address} onChange={(e) => set("address", e.target.value)} required />
          </div>
          <div className="grid grid-cols-3 gap-3">
            <div>
              <label className="field-label">Latitude</label>
              <input type="number" step="any" className="input-soft" value={form.lat} onChange={(e) => set("lat", e.target.value)} />
            </div>
            <div>
              <label className="field-label">Longitude</label>
              <input type="number" step="any" className="input-soft" value={form.lng} onChange={(e) => set("lng", e.target.value)} />
            </div>
            <div>
              <label className="field-label">Tax %</label>
              <input type="number" className="input-soft" value={form.tax} onChange={(e) => set("tax", e.target.value)} />
            </div>
          </div>
          <div>
            <label className="field-label">Minimum Booking Days *</label>
            <input
              type="number"
              min="1"
              className="input-soft"
              value={form.minBookingDays}
              onChange={(e) => set("minBookingDays", e.target.value)}
              required
            />
            <p className="text-xs muted mt-1">Customers must book at least this many days when picking up from this location.</p>
          </div>
          <div className="flex justify-end gap-2 pt-2">
            <button type="button" className="pill-btn outline" onClick={onClose}>Cancel</button>
            <button type="submit" className="pill-btn primary">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}
